
import { Component, Vue } from "vue-property-decorator";
import AuthHeader from "@/components/layout/auth-header.vue";
import LoginFrom, { CodeForm } from "@/lib/form/login/LoginFrom";
import { ElForm } from "element-ui/types/form";
import Info from "@/lib/model/account/info";
import Url from "@/lib/common/url";
import Auth from "@/lib/common/auth";
import Reg from "@/lib/common/Reg";
import Config from "@/config/config";
import vuexStore from "@/store/vuex-store";
import Company from "@/lib/model/company/company";
import { Permission } from "@/lib/model/common";
import { CompanySpecialConfig } from "@/lib/model/exam/candidate-answer";

@Component({
  components: {
    Header: AuthHeader
  }
})
export default class AiLogin extends Vue {
  seconds = 0;
  interval = 0;
  codeForm: CodeForm = new CodeForm();
  loginFrom: LoginFrom = new LoginFrom();
  rules = this.loginFrom.rules();
  formElement!: ElForm;
  sendingCaptchaLock = false;
  loginLock = false;
  returnUrl = Url.query("returnUrl");
  loginError = false;
  errorText = "";
  loginShow = false;
  locationOrigin = "";

  // 添加auth-header中需要的变量
  companies: Company[] = [new Company()];
  currentCompanyId = 0;
  currentCompanyName = "";
  companyLoading = false;
  companyInfo = new Company();
  companyVersion = "";
  CP = new CompanySpecialConfig();
  flagAi = false;

  get isFormValid() {
    return (
      this.loginFrom.phone !== "" &&
      this.loginFrom.phone.length === 11 &&
      this.loginFrom.captcha !== "" &&
      this.loginFrom.captcha.length === 6
    );
  }

  get hasMobile() {
    return this.loginFrom.phone !== "" && this.loginFrom.phone.length === 11;
  }

  mounted() {
    this.formElement = this.$refs["form"] as ElForm;
    this.locationOrigin = Config.homePageHost;
  }

  created() {
    const params = this.$route.query;
    if (params["fromAdmin"] == "1")
      window.sessionStorage.setItem("fromAdmin", "1");
    document.title = "登录";
    const getToken = Auth.token;
    if (getToken) {
      Auth.initUser(false)
        .then(() => {
          // 添加调用authInit
          this.authInit()
            .then(() => {
              this.$router.push("/h5-candidateList");
            })
            .catch(err => {
              console.error("初始化用户信息失败:", err);
              this.loginShow = true;
            });
        })
        .catch(() => {
          this.loginShow = true;
        });
    } else {
      //生产
      if (process.env.NODE_ENV === "production") {
        // oem 登录走 hire360
        if (window.location.host.includes("hire360")) {
          window.location.href = "http://www.hire360.cn/login?type=2";
          return;
        }
        // !薪人薪事那边需要用ai.hina.com这个域名申请从他们系统发送短信，他们短信供应商不允许提供有二次跳转的域名，
        // !因此这里不做跳转
        //三端登录
        // window.location.href = Config.homePageHost + "/login";
      }
      // 移除开发环境强制跳转到根路径
      // else {
      //   //开发
      //   this.$router.push("/");
      // }
      this.loginShow = true;
    }
  }

  // 复制 auth-header.vue 中的 authInit 方法并简化
  async authInit() {
    try {
      await Auth.init(false);

      // 设置必要变量
      this.currentCompanyId = parseInt(vuexStore.company.id);
      Auth.companyId = vuexStore.company.id;
      Auth.companyList = vuexStore.companies;
      this.currentCompanyName = vuexStore.company.name;
      this.companies = vuexStore.companies;
      this.companyInfo = vuexStore.company;
      this.companyVersion = vuexStore.companyPower.version;

      // 检查是否新版AiBuilder
      this.flagAi =
        ([
          80976,
          82070,
          80978,
          559,
          80933,
          80934,
          80935,
          81022,
          81023,
          81025,
          81027,
          81041,
          81044,
          81043,
          81042,
          81040,
          81039,
          89792,
          81177,
          81175,
          81191,
          81190,
          81189,
          81188,
          3
        ].includes(Number(Auth.companyId)) ||
          Number(Auth.companyId) >= 91353) &&
        ![91415, 194].includes(Number(Auth.companyId));

      // 更新是否新AI标志
      vuexStore.updateIsNewAi(this.flagAi);

      // 检查权限
      if (!this.companyInfo.isEnableAI) {
        this.$router.push("/no-auth").catch(err => err);
        return;
      }

      // 获取用户权限
      const p = await Permission.getPerm();
      this.CP = p.companySpecialConfig;

      // 判断版本
      if (!this.flagAi) {
        vuexStore.updateIsWorker(false);
      } else {
        if (
          this.CP.enableAibuilderExam !== 1 &&
          this.CP.enableWorkerExam !== 1
        ) {
          this.$message.error("用户公司未开通任何版本服务");
          return;
        } else if (
          this.CP.enableAibuilderExam === 1 &&
          this.CP.enableWorkerExam !== 1
        ) {
          vuexStore.updateIsWorker(false);
          return;
        } else if (
          this.CP.enableAibuilderExam !== 1 &&
          this.CP.enableWorkerExam === 1
        ) {
          vuexStore.updateIsWorker(true);
          return;
        } else {
          const cacheIsWorker = localStorage.getItem("isWorker");
          if (cacheIsWorker) {
            vuexStore.updateIsWorker(cacheIsWorker === "true");
          } else {
            vuexStore.updateIsWorker(false);
          }
        }
      }

      return true;
    } catch (error) {
      console.error("authInit 初始化失败:", error);
      throw error;
    }
  }

  goHome() {
    this.$router.push({
      path: "/",
      query: this.$route.query
    });
  }

  checkMobileNumber(e: Event) {
    this.loginFrom.phone = (e.target as HTMLInputElement).value.replace(
      /[^\d]/g,
      ""
    );
  }

  getCode() {
    if (this.loginFrom.phone !== "" && this.loginFrom.phone.length === 11) {
      if (this.sendingCaptchaLock) {
        return;
      }
      if (this.seconds > 0) {
        return;
      }
      this.sendingCaptchaLock = true;
      // 获取验证码
      this.codeForm.phone = this.loginFrom.phone;
      Info.getCode(this.codeForm)
        .then(() => {
          this.seconds = 60;
          this.interval = setInterval(() => {
            this.seconds--;
            if (this.seconds <= 0) {
              clearInterval(this.interval);
              this.sendingCaptchaLock = false;
            }
          }, 1000);
        })
        .catch((err: any) => {
          this.errorText = err.message;
          this.loginError = true;
        })
        .finally(() => {
          this.sendingCaptchaLock = false;
        });
    }
  }

  login() {
    if (this.loginLock) {
      return;
    }
    if (!this.isFormValid) return;
    this.loginLock = true;

    this.loginError = false;
    return Info.loginByMobileCaptcha(this.loginFrom)
      .then(() => {
        // 登录成功后调用 authInit 再跳转
        this.authInit()
          .then(() => {
            window.location.href = "/h5-candidateList";
          })
          .catch(err => {
            console.error("初始化用户信息失败:", err);
            window.location.href = "/h5-candidateList"; // 即使失败也跳转
          });
      })
      .catch((err: any) => {
        this.errorText = err.message;
        this.loginError = true;
      })
      .finally(() => {
        this.loginLock = false;
      });
  }
}
